/**
 * Age category for a player, from the tenant's category master.
 *
 * Mirrors CategoryMaster::getCategoryByAge() on the backend: categories are
 * checked in sort order, and a missing min_age/max_age is open-ended (the top
 * category, e.g. Senior, is usually stored with max_age = NULL).
 */

// Age in completed years on `onDate`, or null for an empty/partial date.
// While a year is being typed the date input reports 0002-, 0020-, 0200-...,
// so anything before 1900 is treated as not entered yet.
export const getAgeFromDob = (dob, onDate = new Date()) => {
  if (!dob) return null
  const birth = new Date(dob)
  if (Number.isNaN(birth.getTime()) || birth.getFullYear() < 1900) return null

  let age = onDate.getFullYear() - birth.getFullYear()
  const monthDiff = onDate.getMonth() - birth.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && onDate.getDate() < birth.getDate())) {
    age--
  }
  return age
}

export const findCategoryForAge = (age, categories = []) => {
  if (age === null || age === undefined) return null
  return [...categories]
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
    .find(cat =>
      (cat.min_age === null || cat.min_age === undefined || age >= cat.min_age) &&
      (cat.max_age === null || cat.max_age === undefined || age <= cat.max_age)
    ) || null
}

// Category name for a date of birth, or '' when no category covers that age.
export const getCategoryNameForDob = (dob, categories) =>
  findCategoryForAge(getAgeFromDob(dob), categories)?.name || ''
